import { Typography } from "@mui/material";
import { styled } from "@mui/system";
import RequiredIndicator from "@/app/(protected)/components/RequiredIndicator";

const CustomFormLabel = styled((props: any) => (
  <Typography
    variant="subtitle2"
    fontWeight={600}
    {...props}
    component="label"
    htmlFor={props.htmlFor}
  >
    {/* Adicionando um asterisco após o texto do rótulo se 'required' for verdadeiro */}
    {props.children}
    {props.required && <RequiredIndicator />}
  </Typography>
))(() => ({
  marginBottom: "3px",
  marginTop: "25px",
  display: "block",
}));

export default CustomFormLabel;
